import React from 'react';
import { Group, Skeleton } from '@landr/maestro';
import * as Styled from './Byline.styled';

const Byline = ({
    isLoading,
    byline,
}: {
    isLoading: boolean;
    byline?: string;
}) => {
    if (!byline) {
        return null;
    }

    return isLoading ? (
        <Group.Item>
            <Styled.FirstBylineSkeletonWrapper>
                <Skeleton />
            </Styled.FirstBylineSkeletonWrapper>
            <Styled.SecondBylineSkeletonWrapper>
                <Skeleton />
            </Styled.SecondBylineSkeletonWrapper>
        </Group.Item>
    ) : (
        <Group.Item>
            <Styled.Byline contrast="low" size="lg">
                {byline}
            </Styled.Byline>
        </Group.Item>
    );
};

export default Byline;
